// 解决传音手机部分机型问题处理
export const fixIosVoice=()=> {
    const ua = window.navigator.userAgent.toLowerCase();
    // 判断是否是传音手机
    let whiteList=['tecno','infinix','s10-kc','sm-g970n','samsung']
    let isWhiteList=whiteList.some(item=>ua.includes(item))
   return isWhiteList
}
// 判断是否能获取到css中 safe-area-inset-top变量
export const isSafeAreaInsetTop=()=>{
// 1. 创建隐藏的测试元素
  const testElement = document.createElement('div');
  testElement.style.position = 'absolute';
  testElement.style.visibility = 'hidden';
  testElement.style.top = '0px'; // 初始值
  
  // 2. 同时设置 env 和 constant（兼容iOS不同版本）
  // constant 是 iOS < 11.2 的写法，env 是 iOS >= 11.2 的写法
  testElement.style.top = 'constant(safe-area-inset-top, 1px)';
  testElement.style.top = 'env(safe-area-inset-top, 1px)';
  
  // 3. 将元素添加到文档（否则无法计算样式）
  document.body.appendChild(testElement);
  
  // 4. 获取计算后的样式值
  const computedStyle = window.getComputedStyle(testElement);
  const topValue = computedStyle.getPropertyValue('top');
  
  // 5. 清理测试元素
  document.body.removeChild(testElement);
  
  // 6. 判断是否支持：
  // - 支持的浏览器会解析 env/constant，值不是初始的 0px；
  // - 不支持的浏览器会忽略该属性，值仍为 0px
  return topValue 
}